import { getCurrentTime } from "sb-resp-utils";
import { DateFromISO } from "sb-js-extends";
DateFromISO();
export var getISODate = function (dateISOString, currentTimeZone) {
    var convertedDate = Date.fromISO(dateISOString);
    return convertedDate ? getCurrentTime(convertedDate, currentTimeZone) : undefined;
};
//# sourceMappingURL=getISODate.js.map